import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-dynamic-listing',
  templateUrl: './dynamic-listing.component.html',
  styleUrls: ['./dynamic-listing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class DynamicListingComponent {
  @Output() onListItemClick = new EventEmitter<Object>();
  @Input() dynamicList;
  @Input() header: string = '';

  constructor() {}

  emitListItemData(listItem: Object) {
    this.onListItemClick.emit(listItem);
  }
}
